import Vue from 'vue'
import router from 'router'
import axios from 'axios'


const instance = axios.create({
    timeout: 60 * 1000
  })

  instance.defaults.baseURL = '/gateway/'
  
// 请求拦截器，所有的请求在发送到服务器之前，会被拦截器给拦住
instance.interceptors.request.use(config => {
  if (config.url !== 'login') {
    config.headers.Authorization = localStorage.getItem('token')
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
// 配置响应拦截器
instance.interceptors.response.use((response) => {
  if (response.status === 200 ) {
    if (response.data.hasOwnProperty('code') && response.data.code != 0) {
      // this.$toast.success(response.data.msg);
      Vue.prototype.$toast.success(response.data.msg)
    }
    return response;
  } else {
    Vue.prototype.$toast.fail(response.data.msg)
    return Promise.reject(response.data.msg || response.status)
  }
}, (error) => {
  if (error.response.data.code == 401) {
    // localStorage.removeItem('token')
    //如果返回401，需要跳到login页面；
    if (!window.location.hash.includes('Login') && !window.location.hash.includes('accountLogin')){
      localStorage.removeItem('token');
       router.push("/Login");
    } 
  } else if (error.request.status == 401) {
    //  //如果返回401，需要跳到login页面；
    if(!window.location.hash.includes('Login') && !window.location.hash.includes('accountLogin')){
      localStorage.removeItem('token');
       router.push("/Login");
    } 
  } 
  //this 等于 undefined
  Vue.prototype.$toast.fail(error.response.data.msg)
  return Promise.reject(error)
})


// 配置axiso
Vue.prototype.$axios = instance

export default instance
  